import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Download, Mail, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const Success = () => {
  const [params] = useSearchParams();
  const ref = params.get("ref") || "NRT-DEMO";
  const total = params.get("total") || "0.00";
  const email = params.get("email") || "you@example.com";

  return (
    <div data-testid="success-page" className="bg-slate-50">
      <div className="mx-auto max-w-3xl px-4 py-20 sm:px-6 lg:px-8">
        <div className="border-2 border-slate-900 bg-white p-8 shadow-[12px_12px_0_0_rgba(16,185,129,1)]">
          <div className="flex h-12 w-12 items-center justify-center bg-emerald-500">
            <CheckCircle2 className="h-7 w-7 text-white" strokeWidth={2.5} />
          </div>
          <div className="mt-6 text-xs font-bold uppercase tracking-[0.2em] text-emerald-600">
            Payment successful
          </div>
          <h1 className="mt-2 font-display text-4xl font-black tracking-tighter text-slate-900 sm:text-5xl">
            You&apos;re protected.
          </h1>
          <p className="mt-3 text-base text-slate-600">
            Thanks for your purchase. Your Huntheal activation keys are on the way.
          </p>

          <div className="mt-8 grid gap-4 sm:grid-cols-3">
            <Field label="Order Reference" value={ref} testid="success-ref" />
            <Field label="Amount Paid" value={`$${parseFloat(total).toFixed(2)}`} testid="success-total" />
            <Field label="Email" value={email} testid="success-email" />
          </div>

          <div className="mt-8 border border-slate-200 p-5">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">
              What&apos;s next
            </div>
            <ul className="mt-3 space-y-3 text-sm text-slate-800">
              <li className="flex items-start gap-3">
                <span className="flex h-7 w-7 shrink-0 items-center justify-center bg-emerald-500">
                  <Mail className="h-4 w-4 text-slate-900" />
                </span>
                Check your inbox for the activation email (sent to {email}).
              </li>
              <li className="flex items-start gap-3">
                <span className="flex h-7 w-7 shrink-0 items-center justify-center bg-emerald-500">
                  <Download className="h-4 w-4 text-slate-900" />
                </span>
                Download Huntheal and sign in with your activation code to start protection.
              </li>
            </ul>
          </div>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <Button
              asChild
              data-testid="success-shop-more-btn"
              className="rounded-sm bg-slate-900 text-white hover:bg-slate-800"
            >
              <Link to="/products">
                Shop More <ChevronRight className="ml-1 h-4 w-4" />
              </Link>
            </Button>
            <Button
              asChild
              variant="outline"
              data-testid="success-home-btn"
              className="rounded-sm border-slate-300 hover:border-slate-900"
            >
              <Link to="/">Back to home</Link>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

const Field = ({ label, value, testid }) => (
  <div className="border border-slate-200 p-4">
    <div className="text-[10px] font-bold uppercase tracking-[0.2em] text-slate-500">{label}</div>
    <div
      data-testid={testid}
      className="mt-1 truncate font-display text-sm font-bold text-slate-900"
    >
      {value}
    </div>
  </div>
);

export default Success;
